export enum ProjectChecklistItemLegend {
  Completed = 'Completed',
  InProgress = 'In Progress',
  ToDo = 'To Do'
}
